/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthService, NbAuthResult } from '@nebular/auth';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN, NUMBERS_PATTERN } from '../constants';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { OtpVerifyDialogComponent } from '../otp-verify-dialog/otp-verify-dialog.component';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { UserData } from '../../../@core/interfaces/common/users';
import { MailIntegration } from '../../../@core/interfaces/common/mailIntegration';

@Component({
  selector: 'ngx-request-password-page',
  styleUrls: ['./request-password.component.scss'],
  templateUrl: './request-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxRequestPasswordComponent implements OnInit {
  @Input() tenantId: any;
  @Input() customerId: any;
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  redirectDelay: number = this.getConfigValue('forms.requestPassword.redirectDelay');
  showMessages: any = this.getConfigValue('forms.requestPassword.showMessages');
  strategy: string = this.getConfigValue('forms.requestPassword.strategy');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  protected readonly unsubscribe$ = new Subject<void>();
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  requestPasswordForm: FormGroup;
  isMobileNumberRequired: boolean = this.getConfigValue('forms.validation.mobileNumber.required');
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  isOtpDia: boolean =false;
  showmobileerrormsg: boolean =false;
  phoneNumber: any;
  OTPid:any;
  otpVerification:any;

    // To declare sms_dto to set values written by Abirami Paramasivam / 24.05.21
    smsdto={"variables":[],"template_id":"","to":"","service":"T"};
    branchName: string; 
    tenantUserId:any;
    get apiUrl(): string {
    return environment.apiUrl;
   }
    customerData : any;
    smscontent:string;
    validtime:string;
    smsotp:string;
    templateData:any;
    branchID:string;
    sendthroughsms:boolean=false;
    toGetEmail:boolean=false;
    mailVerified:boolean=false;
    emailId : any;
    verifyMailSuccess:boolean=false;
    verifyMailFailed:boolean=false;

    // For email OTP possibility check, mirrors the sms flags above:-
    emailcontent:string='';
    emailTemplateData:any;
    sendthroughemail:boolean=false;



  constructor(protected userService: UserData,public DatService:DateService,protected rolesService: RolesData,protected service: NbAuthService,protected tenantSrvc: TenantData,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected cd: ChangeDetectorRef,protected patRegSrvc: PatientRegistrationData,
              protected fb: FormBuilder,
              protected mailSrvc: MailIntegration,
              protected router: Router) { }

  get email() { return this.requestPasswordForm.get('email'); }
  get mobileNumber() { return this.requestPasswordForm.get('mobileNumber'); }

  ngOnInit(): void {
    console.log("customer Id in request pwd...",this.customerId);
    console.log("tenant Id in request pwd...",this.tenantId);
    const passwordValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    this.isEmailRequired && passwordValidators.push(Validators.required);
    const mobileNumberValidators = [
      Validators.pattern(NUMBERS_PATTERN),
    ];
    this.isMobileNumberRequired && mobileNumberValidators.push(Validators.required);
    this.requestPasswordForm = this.fb.group({
    mobileNumber: this.fb.control('', [...mobileNumberValidators]),
    tenantId: this.fb.control(''),
    emailId: this.fb.control('',[Validators.email]),
    });
  }

  backToLogIn()
  {
    this.diaClose.emit(null);
  }
  requestPass(): void {
    this.requestPasswordForm.controls["tenantId"].setValue(this.tenantId);

    this.errors = this.messages = [];
    this.submitted = true;
    this.user = this.requestPasswordForm.value;


    this.service.requestPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      console.log("request password success.......",result);
      if (result.isSuccess()) {
        this.messages = result.getMessages();
      //  this.sendOtp();
       this.sendsms();
      } else {
        this.errors = result.getErrors();
      }

      this.cd.detectChanges();
    });
  }
  sendOtp() {
    this.phoneNumber = this.requestPasswordForm.get('mobileNumber').value;
    this.patRegSrvc.sendMessageOtp("patientportalnewuser/" + this.tenantId + '/sendotp/' + this.phoneNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      // SECURITY: backend no longer returns the OTP value, only { success, message }.
      this.OTPid = data && data.success ? 'sent' : '';
    }, (error) => {
     

    }, () => {
      this.isOtpDia = true;
      this.cd.detectChanges();

      this.otpVerifyInstance.fromforgotPassword("forgotPassword")

    });

  }
  onOtpDiaClose(data: any): void {
    if (data == null)
      {
        this.isOtpDia = false;
        this.diaClose.emit(null);
      }
    else if (data.otpStatus == "approved" || data.otpStatus == "success") {
      this.isOtpDia = false
      this.diaClose.emit({otpVerified:data.otpStatus,resetMobileNum:this.phoneNumber})
     }
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
  verifyMobileIsexist()
  {
    this.errors = [];
    this.phoneNumber = this.requestPasswordForm.get('mobileNumber').value;
    if(!!this.phoneNumber && this.phoneNumber!=undefined){
    this.userService.getBranchList(`users/mobile/${this.phoneNumber}/${localStorage.getItem("responseTenantId")}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.length>0){
        this.branchID=data[0].id;
        this.getotpsms();
        this.showmobileerrormsg=false;
      }
      else{
        this.showmobileerrormsg=true;
      }
      
    }, (error) => {

    }, () => {
     
    });
    }
  }

  getotpsms(){
    let data = {
      "headers": {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }
    var url = `${this.apiUrl}/patientportalnewuser/${this.tenantId}/sendotp/${this.phoneNumber}`;
    if(this.emailId && this.verifyMailSuccess){
      url += `/${this.emailId}`;
    }
    this.rolesService.create(url,data).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
     // SECURITY: backend no longer returns the OTP value, only { success, message }.
     this.OTPid = data && data.success ? 'sent' : '';
      this.checksmspossibility();
    }, (error) => {
    }, () => {
    });
  }

  // To check sms send or not based on credit limit and template purchase based:-
  checksmspossibility(){
    let templateData;
    let istemplatepurchase;
    let isemailtemplatepurchase;
    this.rolesService.list(`ezsTemplateMst/purchasedTemplateDetails/${this.tenantId}/${this.branchID}`).subscribe(data => {
      templateData=data;
      if(!!data){
        this.smscontent="Ezovion employees never ask for OTP. Sharing it with anyone allows unauthorized access to your Ezovion account. Your OTP is " + this.OTPid + ". It will be valid for 2 minutes only. Thanks, Ezovion.";
          istemplatepurchase = templateData.sms.purchasedTemplateDet.filter(x =>x.commonTemplateMstDet?.smsTemplateNameMst?.templateName.toLocaleLowerCase() == "ezovion-otp")
          if(istemplatepurchase?.length>0){
            if(istemplatepurchase.length-1>-1){
              if(istemplatepurchase[istemplatepurchase.length-1]?.creditBalance > 0){
                this.sendthroughsms=true;
                this.templateData=istemplatepurchase[istemplatepurchase.length-1];
                // SECURITY: this used to re-send the OTP text through the tenant's purchased
                // SMS gateway by embedding the plaintext OTP value in the message. The OTP is
                // no longer available client-side, so this.smscontent above no longer contains
                // a real code and this second delivery is disabled to avoid sending a broken
                // "Your OTP is sent." message and burning the tenant's paid SMS credit.
                // Re-enable only after moving this delivery server-side (e.g. into
                // AutoCommunGroupRepository.SendSMSOTPToUser), where the generated code exists.
                // this.sendSMS(istemplatepurchase[istemplatepurchase.length-1]);
              }
            }
            else{
              this.sendthroughsms=false;
            }
          }
          else{
            this.sendthroughsms=false;
          }

          // To check email OTP send or not based on credit limit and template purchase, same as
          // the sms check above, only when the user has entered/verified an email id:-
          if(this.emailId && templateData.availableMailCreditCount?.purchasedTemplateDet){
            this.emailcontent="Ezovion employees never ask for OTP. Sharing it with anyone allows unauthorized access to your Ezovion account. Your OTP is " + this.OTPid + ". It will be valid for 2 minutes only. Thanks, Ezovion.";
            isemailtemplatepurchase = templateData.availableMailCreditCount.purchasedTemplateDet.filter(x =>x.commonTemplateMstDet?.emailTemplateNameMst?.templateName.toLocaleLowerCase() == "ezovion-otp")
            if(isemailtemplatepurchase?.length>0){
              if(isemailtemplatepurchase.length-1>-1){
                if(isemailtemplatepurchase[isemailtemplatepurchase.length-1]?.creditBalance > 0){
                  this.sendthroughemail=true;
                  this.emailTemplateData=isemailtemplatepurchase[isemailtemplatepurchase.length-1];
                  // SECURITY: same reasoning as the sms delivery above - the OTP value is no
                  // longer available client-side, so this.emailcontent doesn't contain a real
                  // code. Do not send here; re-enable only once the actual OTP email delivery is
                  // moved server-side (mirroring the sms fix), where the generated code exists.
                  // this.sendEmailOtp(this.emailTemplateData);
                }
              }
              else{
                this.sendthroughemail=false;
              }
            }
            else{
              this.sendthroughemail=false;
            }
          }
          else{
            this.sendthroughemail=false;
          }

          this.isOtpDia = true;
          this.cd.detectChanges();
          this.otpVerifyInstance.fromforgotPassword("forgotPassword")
      }
    }, (error) => {
    }, () => {
    });
  }

  getJson(str: string): any {
    var strVal = str.replace(/\'/gi, '\"');
    return JSON.parse(strVal);
  }

  // To send sms for registration save and update:-
  sendSMS(templateData){
    let smstrackingDetails={
      referencefrom:"ezovion otp",
      referencenum:'0',
      mobileNumber:this.phoneNumber,
      dateTime:this.DatService.currentDate(),
      message:this.smscontent,
      smsUnit:1,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      status:"ok",
      templateId:templateData.commonTemplateMstDet.templateDetId,
      createdIp:null,
      createdby:parseInt(localStorage.getItem("userId")),
      createddate:this.DatService.currentDate(),
      tenantId:this.tenantId,
      branchId:this.branchID
    }
    
    let smsContent={
      text:this.smscontent,
      mobile:this.phoneNumber,
      apiURL:templateData.smsgatewaysettingsDet.providerUrl,
      apiKey:templateData.smsgatewaysettingsDet.providerKey,
      route:templateData.smsgatewaysettingsDet.serviceType,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      tenantId:this.tenantId,
      branchId:this.branchID,
      smstrackingDetails:smstrackingDetails,
      tenantApiConfigId:templateData?.tenantApiConfigId,
    }
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${this.tenantId}/sendSMS`, smsContent).subscribe(data => {
    }, (error) => {
    }, () => {
    });
  }

  // To send OTP through email, mirrors sendSMS above:-
  sendEmailOtp(emailTemplateData){
    const loadData = {
      "Content": this.emailcontent,
      "isTemplate": emailTemplateData,
      "Provider": emailTemplateData?.emailgatewaysettingsDet?.providerName,
      "Subject": `Ezovion OTP Verification`,
      "HtmlContact": `<html><head><title></title></head><body><p>${this.emailcontent}</p></body></html>`,
    };
    this.mailSrvc.sendMailMessage(loadData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data?.response_type === "success"){
        const emailTrackingDetails = {
          referenceFrom: "ezovion otp",
          referenceNum: 0,
          createdDateTime: this.DatService.currentDate(),
          receiverEmailId: this.emailId,
          emailMessage: this.emailcontent,
          emailUnit: 1,
          senderEmailId: emailTemplateData?.emailgatewaysettingsDet?.senderEmail,
          sentStatus: "ok",
          tenantId: this.tenantId,
          branchId: this.branchID,
          emailConfigId: emailTemplateData?.emailConfigId,
        };
        this.rolesService.create(`${this.apiUrl}/emailConfigMst/PostEmailTrackingDet`, emailTrackingDetails).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        }, (error) => {
        }, () => {
        });
      }
    }, (error) => {
    }, () => {
    });
  }

  // To implement sms send function written by Abirami Paramasivam / 24.05.21
  sendsms(){
    this.tenantId ="E91B1784-7C0D-4A39-7E62-08D8F2BE6605";
    
    //https://localhost:44389/api/tenants/E91B1784-7C0D-4A39-7E62-08D8F2BE6605/tenantmst/phoneNum/9843561297
    // To set template variables and template id for to send sms using these template id written by Abirami Paramasivam / 24.05.21

    this.user = this.requestPasswordForm.value;

    this.tenantSrvc.getCustomerId(`${this.apiUrl}/tenants/${this.tenantId}/tenantmst/phoneNum/${this.user.mobileNumber}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.customerData = data;
    }, (error) => {
    }, () => {

      this.smsdto.variables=[this.customerData.name,this.customerData.tenantUserId];
      this.smsdto.template_id = "d4c2ade9-a4bf-406c-8b84-9212342c2de3"; 
  
      // To call server side api for sms sending written by Abirami Paramasivam / 24.05.21
      this.patRegSrvc.sendgreetingsMessage("communication/" + this.tenantId + '/' + this.tenantId + '/send_greetings_message/' + this.user.mobileNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
       }, (error) => {
       }, () => {
       });
    });
  }

  getEmail(){
    this.toGetEmail = true;
  }

  verifyMail(event: Event) : void{
    this.verifyMailSuccess = false;
    this.verifyMailFailed = false;
    const input = event.target as HTMLInputElement;

    if(input.value.length > 0){
     this.mailVerified = true;
    }
  }

  verifyByEmail(){
    this.verifyMailFailed = false;
    this.emailId = this.requestPasswordForm.get('emailId')?.value;
    if(!!this.emailId && this.emailId!=undefined){
    this.userService.getBranchList(`users/isExistMail/${this.emailId}/${localStorage.getItem("responseTenantId")}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data?.success === true){
        this.verifyMailSuccess = true
         this.cd.detectChanges();
      }
      else{
        this.verifyMailFailed = true;
        this.cd.detectChanges();
      }
    }, (error) => {
       this.verifyMailFailed = true;
       this.cd.detectChanges();
    }, () => {
     
    });
    }
  }

  cancelEmail(){
    this.toGetEmail = false;
    this.mailVerified = false;
    this.verifyMailSuccess = false;
    this.verifyMailFailed = false;
    this.requestPasswordForm.get('emailId')?.setValue(null);
  }

}
